"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const component_link_1 = require("@patternplate/component-link");
const component_text_1 = require("@patternplate/component-text");
exports.StyledSearchLegend = styled_components_1.default.div `
  display: flex;
  align-items: center;
  height: 30px;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 0 15px;
  border: 1px solid ${props => props.theme.colors.border};
  color: ${props => props.theme.colors.border};
  ${props => withTint(props)};
`;
exports.StyledSearchLegendBox = styled_components_1.default.div `
  display: flex;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  position: relative;
  z-index: 1;
  ::-webkit-scrollbar {
    display: none;
  }
`;
exports.StyledField = styled_components_1.default(component_text_1.Text) `
  padding: 0 10px;
  color: ${props => props.theme.colors.color};
  &:first-child {
    padding-left: 0;
  }
`;
exports.StyledLegendName = styled_components_1.default(exports.StyledField) `
  padding-right: 20px;
  font-weight: bold;
  color: ${props => props.theme.colors.color};
  position: relative;
  z-index: 1;
`;
exports.StyledFieldLink = styled_components_1.default(component_link_1.Link) `
  white-space:nowrap;
  &:link,
  &:active,
  &:visited,
  &:hover {
    color: ${props => props.theme.colors.color}
  }
`;
function withTint(props) {
    return `
		&::before {
			content: '';
			position: absolute;
			z-index: 0;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: ${props.theme.colors.background};
			opacity: 0.975;
		}
	`;
}
//# sourceMappingURL=search-legend.styles.js.map